import moment from "moment";

export const DD_MMM_YYYY = "DD MMM YYYY";
export const YYYY_MM_DD_HH_mm_ss = "YYYY-MM-DD HH:mm:ss";
export const YYYY_MM_DD = "YYYY-MM-DD";
export const dateFormatHandler = (date: any, type: string) => {
  if (!date) return "-";
  return moment(date).format(type);
};
